import { useState } from 'react';
import { faqData } from '@/mocks/hoobuyData';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-3.5 py-1.5 rounded-full border border-background-300 text-xs font-medium text-foreground-600 mb-4">
            FAQ
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Perguntas Frequentes sobre Hoobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            Tire suas dúvidas sobre como usar o Hoobuy Spreadsheet e fazer compras seguras
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center shrink-0 transition-transform duration-200 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-lg text-foreground-400"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}